import "./Input.css";
import React, { forwardRef } from "react";

// Define the props that the Input component will accept
interface InputProps {
  label: string;
  type: string;
  id: string;
  placeholder?: string;
  required?: boolean;
  value?: string;
  onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void;
  name: string;
  onBlur?: React.FocusEventHandler<HTMLInputElement>;
}

const Input = forwardRef<HTMLInputElement, InputProps>(
  (
    { label, type, id, placeholder, required, name, value, onChange, onBlur },
    ref,
  ) => {
    return (
      <div className="inputContainer">
        {label?.trim() && (
          <label htmlFor={id} className="inputLabel">
            {label}
            {required && "*"}
          </label>
        )}
        <input
          ref={ref} // ✅ forward the ref here
          type={type}
          id={id}
          className="formInput"
          placeholder={placeholder}
          required={required}
          value={value}
          onChange={onChange}
          name={name}
          onBlur={onBlur}
        />
      </div>
    );
  },
);

export default Input;
